export const DEFAULT_RESEARCH_EMAIL_ADDRESS = 'research@covenantreview.com';
export const DEFAULT_SUBSCRIPTIONS_EMAIL_ADDRESS = 'subscriptions@creditsights.com';
